:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: calc(var(--spacer) * 4) calc(var(--spacer) * 5);
  display: inline-flex;
  flex-direction: column;
}

gz-form-field[id='selected-targets-label'] {
  &::part(form-field-label) {
    color: var(--main-titles-inputs-600);
    font-weight: 400;
    padding-right: var(--spacer);
    width: 165px;
    max-width: 165px;
  }
}

.selection-tree-label {
  min-width: 165px;
  max-width: 165px;
  color: var(--main-titles-inputs-600);
  --font-family: var(--font-family-secondary);
}

.location-selector {
  flex: 1;
}

.selection-target {
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
}

gz-push-body-layout {
  max-height: 495px;
  &::part(header) {
    display: none;
  }

  &::part(sideNav) {
    background-color: var(--white-layout-301-level-0-elevation);
    border: 1px solid var(--chart-101-pressed-dividers);
    border-radius: 4px;
    padding: var(--spacer) calc(var(--spacer) + 4px) var(--spacer) calc(var(--spacer) + 4px);
    min-width: 320px;
    overflow: hidden;
  }

  &::part(push-body-layout-sidenav-content) {
    height: 100%;
  }
}

gz-chips-generator-input {
  --chip-list-max-height: 162px;
}

.font-italic {
  font-style: italic;
}

.selection-target {
  width: 488px;
}

gz-network-tree {
  height: auto;
  --network-tree-input-padding: 0;

  &::part(network-content-tree) {
    max-height: 420px;
    overflow: auto;
  }
}

.error-notification {
  color: var(--red-layout-300-primary);
  gz-text {
    color: var(--red-layout-300-primary);
  }
}

gz-icon[class*='notification-negative-icon'] {
  &::part(svgIcon) {
    fill: var(--red-layout-300-primary);
  }
}

.select-destination-text {
  color: var(--chart-300-icon-buttons);
  text-transform: uppercase;
}
